
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1602657827986",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1636",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M876.544 661.504l-367.104 204.8-369.152-206.848-97.792 55.296L507.904 972.8l464.896-258.048-96.256-53.248z",
        "fill": "#FF6A00",
        "p-id": "1637"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M166.4 326.656v281.6l85.504 42.496V326.656c8.704-6.144 16.896-14.848 23.552-25.6 4.096-10.752 8.704-21.504 8.704-29.696l223.744-130.048 256 147.456v296.448l-204.8 117.248c-4.096-4.096-10.752-8.704-14.848-10.752-36.352-19.456-80.896-4.096-100.352 31.744-19.456 36.352-4.096 80.896 31.744 100.352 36.352 19.456 80.896 4.096 100.352-31.744v-2.048l272.896-157.696V239.104L507.904 42.496 239.104 198.656c-36.352-14.848-76.8 0-96.256 34.304-16.896 31.744-6.144 74.24 23.552 93.696z",
        "fill": "#FF6A00",
        "p-id": "1638"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M612.352 270.848c-27.648-6.144-45.056-64-113.152-87.552-10.752-2.048-12.8 57.344-19.456 64-6.144 6.144-57.344 21.504-87.552 40.448-47.104 31.744-98.304 96.256-113.152 179.2-31.744 213.504 181.248 159.744 202.752 153.6 16.896 8.704 82.944 19.456 93.696 16.896s21.504-14.848 2.048-27.648c-42.496-27.648-53.248-42.496-57.344-59.904-8.704-59.904-31.744-59.904-36.352-36.352-4.096 19.456-16.896 59.904-34.304 68.096-14.848 6.144-100.352-6.656-76.8-70.656 19.456-40.448 61.952-91.648 136.704-42.496 80.896 53.248 85.504 59.904 108.544 74.752 23.552 14.848 53.248 29.696 76.8 34.304 31.744 6.656 55.296-27.648 31.744-89.6-6.144-16.896 8.704-47.104 8.704-55.296-1.536-8.192 19.968-93.696-122.88-161.792z m51.2 187.904c-6.144 8.704-18.944 8.704-27.648 2.048-8.704-6.144-8.704-19.456-2.048-27.648s19.456-8.704 27.648-2.048c8.192 6.144 10.24 18.944 2.048 27.648z",
        "fill": "#FF6A00",
        "p-id": "1639"
      }
    }
  ]
})
    }
  